export const LAYOUT_CATALOG_DRAG_MIME = 'application/x-monkeys-layout-catalog-item';
